import React from "react";
import AdminCard from "../../components/Admin/AdminCard";
import "../../styles/Admin.css";

export default function AdminDashboard() {
  return (
    <>
      <div className="admin-page-header">
        <h1 className="admin-page-title">Admin Dashboard</h1>
        <p className="admin-page-subtitle">
          Manage users, pricing, and platform settings
        </p>
      </div>

      <div className="admin-dashboard-grid">
        <AdminCard
          title="Users"
          description="View and manage users, access their services"
          link="/admin/users"
        />
        <AdminCard
          title="Pricing Settings"
          description="Configure margins and currency conversion"
          link="/admin/settings/pricing"
        />
        <AdminCard
          title="Visibility Rules"
          description="Enable/disable OS, Apps, and Regions"
          link="/admin/settings/visibility"
        />
        <AdminCard
          title="Menu Manager"
          description="Manage menu links, text, and site logo"
          link="/admin/settings/menu"
        />
      </div>
    </>
  );
}
